import { graphql } from 'react-relay';

export const liveFilterFragment = graphql`
    fragment LiveFilter_liveFilter on LiveFilter {
        placeholder
    }
`;
